import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Button, DataGrid, messageFromError, toast, unwrapAction, useGridConfig } from '@eo/shared';

import type { TaskTypeItem } from './api/types';
import { makeTaskTypesGridConfig } from './config/gridConfig';
import type { TaskTypesTabProps } from './types';

export function TaskTypesTab({ taskTypes, pagination, onSync }: TaskTypesTabProps) {
  const config = useGridConfig(makeTaskTypesGridConfig, {});
  const [syncing, setSyncing] = useState(false);

  const sync = async () => {
    setSyncing(true);
    try {
      unwrapAction(await onSync());
      toast.success('Task types synced from ClickUp.');
    } catch (err) {
      toast.error(messageFromError(err, 'Syncing from ClickUp failed. Try again.'));
    } finally {
      setSyncing(false);
    }
  };

  return (
    <section className="flex flex-col gap-4">
      <p className="text-sm text-text-secondary">
        Managed in ClickUp’s Task Dropdown field and synced once a week. Changed it in ClickUp? Sync
        now to see it here.
      </p>
      <DataGrid<TaskTypeItem>
        config={config}
        rows={taskTypes}
        pagination={pagination}
        headerActions={
          <Button variant="secondary" disabled={syncing} onClick={() => void sync()}>
            <RefreshCw className="size-4" />
            {syncing ? 'Syncing…' : 'Sync from ClickUp'}
          </Button>
        }
      />
    </section>
  );
}
